var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"ml-alert",class:`ml-alert-${_vm.variant}`},[_c('div',{staticClass:"ml-alert-content"},[_vm._m(0),_c('div',{staticClass:"ml-alert-text"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"ml-alert-icon"},[_c('i',{staticClass:"fa fa-question-circle color-primary"})])])
}]

export { render, staticRenderFns }